export {Ng2FlatpickrComponent} from './ng2-flatpickr.component';
export {Ng2FlatpickrModule} from './ng2-flatpickr.module';
export type {FlatpickrOptions} from './flatpickr-options.interface';
